import { render, staticRenderFns } from "./UIFlash.vue?vue&type=template&id=30dd5b5a&scoped=true&"
import script from "./UIFlash.vue?vue&type=script&lang=ts&"
export * from "./UIFlash.vue?vue&type=script&lang=ts&"
import style0 from "./UIFlash.vue?vue&type=style&index=0&id=30dd5b5a&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../vue-loader-virtual-c5444c0a66/0/cache/vue-loader-npm-15.9.1-90a0e5830b-a9a3ffbe3c.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dd5b5a",
  null
  
)

export default component.exports